var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"sw-body-container"},[_c('progress-steps',{attrs:{"currentStep":_vm.currentStep,"progressStepsLabels":_vm.progressStepsLabels}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }